import { TextValue } from "../../tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
export default {
  name: "CurrencyFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    currency: {
      type: String
    },
    symbol: {
      type: String
    },
    selected: {
      type: Boolean,
      default: false
    },
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue
  }
};